import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
/*ElementUI*/
import ele from 'element-ui'

/*********************    前台页面   ************************/
import base from '../views/show/base.vue'
import Home from '../views/show/index.vue'
import Popularity from '../views/show/popularity.vue'
import Account from '../views/show/account.vue'
import AccountInfo from '../views/show/account-info.vue'
import Login from '../views/show/login.vue'
import Forgot from '../views/show/forgot.vue'


/*********************    End   ************************/

// 防止重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
	return originalPush.call(this, location).catch(err => {})
};
Vue.use(VueRouter)

const routes = [
	/**
	 * @type: show 代表前台页面
	 */
	{
		path: '/',
		name: 'root',
		redirect: '/index',
		component: base,
		meta: {
			title: '首頁',
			type: 'show'
		},
		children: [{
				path: '/index',
				name: '首頁',
				component: Home,
				meta: {
					title: '首頁',
					type: 'show'
				}
			},{
				path: '/popularity',
				name: '人氣趨勢追蹤',
				component: Popularity,
				meta: {
					title: '人氣趨勢追蹤',
					type: 'show'
				}
			},{
				path: '/account',
				name: '帳號與個人資料',
				component: Account,
				meta: {
					title: '帳號與個人資料',
					type: 'show'
				}
			},{
				path: '/account-info',
				name: '個人資料',
				component: AccountInfo,
				meta: {
					title: '個人資料',
					type: 'show'
				}
			},
			
			

		]
	},
	{
		path: '/login',
		name: '登入',
		component: Login,
		meta: {
			title: '登入',
			type: 'login'
		}
	},
	{
		path: '/forgot',
		name: '忘記密碼',
		component: Forgot,
		meta: {
			title: '忘記密碼',
			type: 'forgot'
		}
	},

]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		};
	}
})


// 路由守卫
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	document.title = (to.meta.title ? (to.meta.title + '-') : '') + '大學問-招生數據中心';
	// 判断Token是否存在
	let token = localStorage.getItem('Authorization');
	if (to.meta.type == 'member') {
		localStorage.setItem('backurl', to.fullPath);
	};
	if (to.meta.type == 'member' || to.meta.type == 'diy') {
		if (token) {
			next();
		} else {
			ele.Message({
				message: '请先登录',
				type: 'warning'
			});
			next('/')
		}
	} else {
		next()
	}
})
export default router